module.exports = __webpack_public_path__ + "static/images/welcome.eee8335.png";